import Cleave from "cleave.js/react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const NumberField = (props: any) => {
  const {
    placeholder,
    value,
    register,
    errors,
    label,
    delimiter = "",
    setValue,
    onChange = () => {},
    clearErrors,
    onKeyDown,
    disabled = false,
  } = props;
  return (
    <div className={tw`w-full text-left`}>
      <label htmlFor="" className={tw`whitespace-nowrap `}>
        {label}
      </label>
      <Cleave
        type="text"
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2  ${
          label ? "mt-2" : ""
        }  `}
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        onBlur={(e) => clearErrors(register.name)}
        onChange={(e) => {
          setValue(register.name, (e.target as any).rawValue);
          onChange();
        }}
        disabled={disabled}
        onKeyDown={onKeyDown}
        options={{
          numeral: true,
          numeralDecimalMark: ".",
          numeralDecimalScale: 4,
          numeralPositiveOnly: false,
          delimiter: delimiter,
          numeralThousandsGroupStyle: "lakh",
        }}
      />
      {errors && (
        <span
          className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
        >
          <span className={tw`block`}>{errors.message}</span>
        </span>
      )}
    </div>
  );
};

export default NumberField;
